import React, { FC, useContext } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { Routes } from '../../constants';
import { UserContext } from '../../context';
import { IRoleType } from '../../models';
interface IPrivateRouteProps extends RouteProps {
  roles: IRoleType[];
  requiredFeatureFlags?: string[];
}


export const PrivateRoute: FC<IPrivateRouteProps> = ({ roles, requiredFeatureFlags = [], ...routeProps }) => {
  const { userContext } = useContext(UserContext);
  // Check if user has all required feature flags
  // If no feature flags are required, this should return true
  const hasFeatureFlags = requiredFeatureFlags.every(requiredFlagName =>
    userContext?.featureFlags.some(
      flag => flag.name === requiredFlagName && flag.hasAccess === true
    )
  );

  if (userContext?.roles && roles.some(role => userContext.roles.has(role)) && hasFeatureFlags) {
    return <Route {...routeProps} />;
  }
  return <Redirect to={{ pathname: Routes.noAccess }} />;
};
